<template>
  <div class="app-calendar">
   
    <b-button
      size="sm"
      class="btn-icon btn-close"
      variant="flat-primary"
      @click="$emit('close')"
      style="display:none;"
    >
      <feather-icon icon="XIcon" title="Cancelar" />
    </b-button>
  
    <div class="row no-gutters">
      <!-- Sidebar -->
      <!-- <div
        class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
        :class="{ show: isCalendarOverlaySidebarActive }"
      >
        <calendar-sidebar
          :is-event-handler-sidebar-active-send-news.sync="isEventHandlerSidebarActiveSendNews"
          :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive"
          @submit-import-event="submitImportEvent"
          @open-send-news="openSendNews"
        />
      </div> -->

      <!-- Calendar -->
      <div class="col position-relative">
        <!-- <div class="user-task">
              <b-link
                size="sm"
                class="btn-sm btn-nav-link btn-nav-link-white lk- btn-my-sched"
                >
                <feather-icon icon="StarIcon" class="mr-50" />
                <span class="align-middle">Meus Compromissos</span>
              </b-link>
            </div> -->
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0">
            
            <b-overlay
              variant="gray"
              :show="displayOverlay"
              spinner-variant="primary"
              blur="0"
              opacity=".75"
              rounded="sm"
            >
            
            <div class="calen">
              
              <full-calendar
                ref="refCalendar"
                :options="calendarOptions"
                class="full-calendar"
              />
            </div>
            </b-overlay>
            
          </div>
        </div>
      </div>

      <!-- Sidebar Overlay -->
      <div
        class="body-content-overlay"
        :class="{ show: isCalendarOverlaySidebarActive }"
        @click="isCalendarOverlaySidebarActive = false"
      />
      <!-- <calendar-event-handler
        v-model="isEventHandlerSidebarActive"
        :event="event"
        :isEventHandlerSidebarImport="isEventHandlerSidebarImport"
        :clear-event-data="clearEventData"
        @remove-event="removeEvent"
        @add-event="addEvent"
        @update-event="updateEvent"
        @import-event="importEvents"
      /> -->
        
      <calendar-event-detail
        v-model="isEventHandlerSidebarActive"
        :newsViewData="currentNewsDetail"
        @action-edit="$emit('action-edit', $event)"
        @action-copy="$emit('action-copy', $event)"
        @action-schedule="$emit('action-schedule', $event)"
        @action-publish="$emit('action-publish', $event)"
        @action-disable="$emit('action-disable', $event)"
        @action-cancel="$emit('action-cancel', $event)"
        @action-errata="$emit('action-errata', $event)"
      />
      <calendar-event-send-news
        v-model="isEventHandlerSidebarActiveSendNews"
        :newsViewData="currentNewsDetail"
        @load-news-data="refetchEvents"
      />
    </div>
    
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import store from "@/store";
import { onUnmounted, computed } from "@vue/composition-api";
import calendarStoreModule from "./calendarStoreModule";
import CalendarSidebar from "./calendar-sidebar/CalendarSidebar.vue";
// import CalendarEventHandler from "./calendar-event-handler/CalendarEventHandler.vue";
import useCalendar from "./useCalendar";
import AppConstants from '@/appConstants';
import { BButton, BOverlay, BLink } from "bootstrap-vue";
import CalendarEventDetail from './calendar-event-detail/CalendarEventDetail.vue';
import CalendarEventSendNews from './calendar-event-send-news/CalendarEventSendNews.vue';
/* eslint-disable vue/no-unused-components */
import CalendarEventPopover from './calendar-event-popover/CalendarEventPopover.vue';

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    CalendarSidebar,
    BButton,
    CalendarEventDetail,
    CalendarEventSendNews,
    CalendarEventPopover,
    BOverlay,
    BLink,
  },
  methods: {},
  setup() {
    const submitImportEvent = () => {
      // self.$refs["import-event-doc"].click();
      isEventHandlerSidebarActive.value = true;
      isEventHandlerSidebarActiveSendNews.value = true;
      isEventHandlerSidebarImport.value = true;
    };

    // Register module
    if (!store.hasModule(AppConstants.CALENDAR_APP_STORE_MODULE_NAME)){
      store.registerModule(AppConstants.CALENDAR_APP_STORE_MODULE_NAME, calendarStoreModule);
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(AppConstants.CALENDAR_APP_STORE_MODULE_NAME))
        store.unregisterModule(AppConstants.CALENDAR_APP_STORE_MODULE_NAME);
    });

    let origins = computed(() => store.state.calendar.origins);

    const {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      currentNewsDetail,
      displayOverlay,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      fetchEvents,
      refetchEvents,
      calendarOptions,
      importEvents,
      openSendNews,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
      isEventHandlerSidebarActiveSendNews,
      isEventHandlerSidebarImport,
    } = useCalendar();

    fetchEvents();

    return {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      currentNewsDetail,
      displayOverlay,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      calendarOptions,
      origins,
      importEvents,
      openSendNews,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
      isEventHandlerSidebarActiveSendNews,
      isEventHandlerSidebarImport,
      submitImportEvent,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>
